<template>
	<div class="main cf mb60" style="min-height: 582px;padding-top:10px">
		<div class="VipLeft Boxs">

			<div class="List" id="leftMenu">
				<a :class="{cur:tableft == index }" v-for="(tab, index) in tabs" :key="index"
					@click="toggleTab(index)">{{tab.title}}<i></i></a>


			</div>
		</div>
		<div class="VipRight" style="margin-bottom: 10px;cursor: pointer;"><img src="../assets/picture/yaoqing.jpg"
				style="width: 100%;"  @click="changeStatus()"></div>
		<div class="popcont  flex-items-justify-content" v-show="popshow">

			 
				<div class="popbox">
					<div  class="popcancel" @click="changeStatus()">×</div>
					<div  class="titleSlust"><img 
							src="../assets/picture/huodonbggue.png"></div>
					<div class="con_arList"> 为感谢诸位学员对本校的认可和支持，我校针对已报班学员做出以下福利活动： <br
							> 1、当前活动所有已报班的学员均可参与 <br >
						2、介绍学员给销售顾问，学员购买任何视频课程，介绍人享受高额现金返佣。 
					<br > 3、本次活动获得的优惠仅限学员自身使用
							 </div>
				</div>
	 
		</div>
		<Tabhome v-show="tabindex == 0"></Tabhome>
		<Tabkc v-show="tabindex == 1"></Tabkc>
		<Tabtk v-show="tabindex == 2"></Tabtk>
		<Tabzl v-show="tabindex == 3"></Tabzl>
		<Tabzj v-show="tabindex == 4"></Tabzj>
	</div>
</template>
<script>
	import Tabhome from "./tab/tablist.vue";
	import Tabkc from "./tab/tablist1.vue";
	import Tabtk from "./tab/tablist2.vue";
	import Tabzl from "./tab/tablist3.vue";
	import Tabzj from "./tab/tablist4.vue";
	export default {
		props: {
			bank: {
				type: Number,
				default: 0
			},
			list: {
				type: Array,
				default: () => []
			},
			title: String,
		},
		data() {
			return {
				list2: "快捷导航",
				liststatus: false,
				tabs: [{
						"title": "个人中心",
						"path": "home",
						"show": true
					},
					{
						"title": "我的课程",
						"path": "kc",
						"show": false
					},
					{
						"title": "我的题库",
						"path": "tk",
						"show": false
					},
					{
						"title": "学习资料",
						"path": "kc",
						"show": false
					},
					{
						"title": "升值证件",
						"path": "tk",
						"show": false
					},
				],
				popshow:false,
				currentTab: 'home',
				tableft: 0,
				tabindex: 0,
				studyTab: {},
				studyTabList: [],
				subjectList: [],
				listall: [
					"快捷导航",
					"我的课程",
					"我的题库",
					"我的资料",
					"升值证件"
				]
			};
		},
		mounted() {
			this.studyTabList = this.list;
			// this.initQuestion();
			this.initTabData();
			
		},

		computed: {

			currentTabComponent() {
				return 'tab' + this.currentTab.toLowerCase();

			},
			list1() {
				return this.list2;
			}
		},

		methods: {
			toggleTab(index) {

				this.tableft = index;
				this.tabindex = index;


			},
			changeStatus(){
				this.popshow=!this.popshow;
			},
			initTabData() {

				if (this.studyTabList.length > 0) {
					this.studyTab = this.studyTabList[0];
					console.log(this.studyTab);
					this.subjectList = this.studyTabList;
					console.log(this.subjectList);
					this.liststatus = true
				}

			},

		},
		components: {
			Tabhome,
			Tabkc,
			Tabtk,
			Tabzl,
			Tabzj,
		},
	};
</script>
<style lang="less" scoped>
	// @import "../../../assets/css/var.less";
	// @import "../../../assets/css/study.less";
	.popcont {
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, .5);
		position: fixed;
		z-index: 9999;
		left: 0;
		top: 0;
	}

	.popbox {
		width: 748px;
		height: 508px;
		position: relative;
		background-image: url(../assets/picture/tishikuang.png);
		background-size: 100% 100%;
		box-shadow: 6px 2px 21px 0 hsl(0deg 0% 59% / 13%);
		border-radius: 10px;
		overflow: hidden;
	}

	.popcancel {
		font-size: 32px;
		font-family: DFPYuanW3-GB;
		font-weight: 400;
		color: #fff;
		position: absolute;
		cursor: pointer;
		right: 31px;
		z-index: 9;
		top: 10px;
	}

	.popbox .titleSlust {
		font-size: 36px;
		font-family: Source Han Sans CN;
		font-weight: 700;
		color: #fff;
		text-shadow: 0 2px 0 #144196;
		text-align: center;
		padding: 20px 0;
		background: linear-gradient(0deg, #bed4ff, #fff);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.flex-items-justify-content {
		display: flex;
		align-items: center;
	}

	.flex-items-justify-content {
		justify-content: center;
	}

	.popbox .con_arList {
		width: 681px;
		height: 391px;
		background: #fff;
		font-size: 20px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #000;
		line-height: 41px;
		border-radius: 10px;
		margin: 0 auto;
		padding: 35px 47px;
	}

	.VipLeft {
		width: 130px;
		float: left;
		background: #fff;
		padding: 15px 0
	}

	.Fixed {
		position: fixed;
		top: 0;
	}

	.VipLeft .Head {
		padding: 7px 0;
		text-align: center;
	}

	.VipLeft .Head img {
		width: 56px;
		height: 56px;
		border-radius: 50%;
		margin: 0 auto;
	}

	.VipLeft .Head p {
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		color: #999999;
	}

	.VipLeft .List a {
		width: 130px;
		position: relative;
		line-height: 40px;
		display: block;
		text-align: center;
		margin-top: 5px;
		color: #000000;
	}

	.VipLeft .List a i {
		border-color: transparent transparent transparent #f24343;
		border-style: dashed dashed dashed solid;
		border-width: 9px;
		position: absolute;
		right: -18px;
		top: 11px;
		display: none;
	}

	.VipLeft .List a i,
	.VipLeft .List a:active i {
		display: none;
		_display: none !important;
	}

	.VipLeft .List a.cur,
	.VipLeft .List a:hover {
		color: #ffffff;
		background: #f24343;
	}

	.VipLeft .List a.cur i,
	.VipLeft .List a:hover i {
		display: block;
	}

	.VipRight {
		width: 1030px;
		float: right;
	}

	.study-type {
		display: flex;
		width: 100%;
		margin-bottom: 20px;
		justify-content: center;

		li {
			text-align: center;
			font-weight: bold;
			color: #666;
			padding: 5px 20px 10px 20px;
			margin-right: 30px;
			cursor: pointer;
			font-size: 22px;

			&::after {
				content: " ";
				display: block;
				margin: 5px auto 0 auto;
				width: 90px;
				height: 5px;
				background: #fff;
			}

			&:hover {
				color: #2595fd;
			}

			&.active {
				color: #2595fd;

				&::after {
					background: linear-gradient(#27a4ff 21.43%, #227efa 95.7%);
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/mall/study/ExerciseStore.vue
